enum TextLinkIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
enum TextLinkStyle {
  CHEVRON = 'Chevron',
  CHEVRONUNDERLINE = 'Chevron&Underline',
  ICON = 'Icon',
  ICONUNDERLINE = 'Icon&Underline',
  UNDERLINE = 'Underline',
}
enum TextLinkUnderlineStyle {
  HOVER = 'UnderlineOnHover',
  NOHOVER = 'NoUnderlineOnHover',
  FIXED = 'UnderlineFixed',
}
export { TextLinkIconPosition, TextLinkStyle, TextLinkUnderlineStyle };
